function isValidFloodHeight(string) {
  const parsedValue = parseFloat(string);

  return !Number.isNaN(parsedValue) && parsedValue >= 0.1 && parsedValue <= 10;
}

export {
  isValidFloodHeight,
};